import { QueryFunctionContext } from '@tanstack/react-query'
import { GET } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import { User } from '../../../types/user/User'
import userEndpoints from '../api/userEndpoints'
import userQueryKeys from '../queries/userQueryKeys'

export const fetchCompanyUsers = ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof userQueryKeys)['companyUsers']>>) => {
  return backendRequest<User[]>({
    method: GET,
    url: userEndpoints.companyUsers(companyId),
    signal
  })
}
